import { tahunAjaran } from "../action-types";

const initialState = {
  data: [],
  isFetching: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case tahunAjaran.FETCH_TAHUNAJARAN:
      return {
        ...state,
        isFetching: true,
      };
    case tahunAjaran.GET_TAHUNAJARAN:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
      };
    default:
      return state;
  }
};
